module.exports = __webpack_public_path__ + "static/media/pet-happy.38237ac4.png";